import * as Yup from 'yup';

export const weightGoalValidationSchema = Yup.object({
  current_value: Yup.number()
    .required('Current weight is required')
    .min(20, 'Weight must be at least 20kg')
    .max(400, 'Weight must be at most 400kg'),
  target_value: Yup.number()
    .required('Target weight is required')
    .min(20, 'Weight must be at least 20kg')
    .max(400, 'Weight must be at most 400kg'),
  target_date: Yup.date()
    .required('Target date is required')
    .min(
      new Date(Date.now() + 24 * 60 * 60 * 1000),
      'Target date must be tomorrow or later'
    )
});
